/* Right-click "guardar imagen"/"guardar video" deterrent (client request, 2026-08-18).
 * Friction only: blocks the easy one-click path, not a real protection, DevTools /
 * view-source / screenshots still work and he knows that. Loaded only on the product
 * page (from sticker-color-selector.liquid), so this also reaches Dawn's own product
 * media gallery, not just the colour gallery and combo photos/videos we render. */
(function () {
  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest('img, video')) e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest('img, video')) e.preventDefault();
  });

  /* Chrome's native <video> control bar has its own download icon, separate from the
   * right-click menu; controlsList removes it. Gallery/combo videos are built after
   * this script runs, so a one-time querySelectorAll would miss them. */
  var strip = function (v) { v.setAttribute('controlsList', 'nodownload'); };
  document.querySelectorAll('video').forEach(strip);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'VIDEO') strip(n);
        if (n.querySelectorAll) n.querySelectorAll('video').forEach(strip);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
